export const idMapping = {
  HSE: 'HSE',
  CHSE: 'CHSE',
  HSSPD: 'HSSPD',
  'FERPA-R': 'FERPA-R',
  'FERPA-R-DATE': 'FERPA-R',
  'FERPA-PR': 'FERPA-PR',
  'FERPA-PR-DATE': 'FERPA-PR',
  'FERPA-W': 'FERPA-W',
  'FERPA-W-DATE': 'FERPA-W',
  'PTN-HS': 'PTN-HS',
  OUTCOMES: 'OUTCOMES',
  'EARLY-DECISION-CONTRACT': 'EARLY-DECISION-CONTRACT',
  'FEE-WAIVER': 'FEE-WAIVER',
}
